import { SubscriptionState, UserProfile } from '@/state/globalState';
import { isDeveloperUserType } from '@/utils/userRoles';

const PREMIUM_ACTIVE_STATUSES = new Set(['ativa', 'cancelamento_agendado']);

export const hasDeveloperBypass = (userType?: string | null): boolean => {
  return isDeveloperUserType(userType);
};

export const hasPremiumPlanActive = (subscription: Partial<SubscriptionState> | null | undefined): boolean => {
  if (!subscription) return false;
  const status = subscription.status?.toLowerCase();
  const planType = subscription.planType?.toLowerCase();
  return planType === 'premium' && (!!status && PREMIUM_ACTIVE_STATUSES.has(status));
};

export const hasPremiumAccess = (
  subscription: Partial<SubscriptionState> | null | undefined,
  userProfile: UserProfile | null | undefined
): boolean => {
  if (!userProfile) {
    return hasPremiumPlanActive(subscription);
  }

  if (hasDeveloperBypass(userProfile.user_type)) {
    return true;
  }

  return hasPremiumPlanActive(subscription);
};

export const shouldShowUpgradeCta = (
  subscription: Partial<SubscriptionState> | null | undefined,
  userProfile: UserProfile | null | undefined
): boolean => !hasPremiumAccess(subscription, userProfile);

export default {
  hasDeveloperBypass,
  hasPremiumPlanActive,
  hasPremiumAccess,
  shouldShowUpgradeCta,
};
